import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { differenceInCalendarDays } from "date-fns";
import moment from "moment";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { AppsService } from "src/app/shared/services/apps.service";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CommonModule } from "@angular/common";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";

am4core.useTheme(am4themes_animated);

@Component({
  selector: "app-trips-cvrge-scndry-ulb-dashboard",
  templateUrl: "./trips-cvrge-scndry-ulb-dashboard.component.html",
  styleUrls: ["./trips-cvrge-scndry-ulb-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripsCvrgeScndryUlbDashboardComponent implements OnInit {
  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) => this.onCellPrepared(this.columnDefs, e);

  clntDtls: any;
  rdrctUlbDtls;
  tntLst: any = [];
  selectedtenant: any;
  selectedtenantNm: any;
  ulb_id: any;
  userDtls: any;
  tdyCoveredTrips: any[];
  showLdr: boolean;
  curDate;
  slctdDt = new Date();
  today = new Date();
  dateFormat = "dd/MM/yyyy";
  dbrd_ky = "ULB";
  tripsData: any[];
  columnDefs: any = [];
  rowselected: any;
  curYr: string;
  toptripsData: any = [];
  topTripscolumnDefs: any = [];
  ttlColumnDefs: any[];
  cvrge_prcnt: number;
  avg_cvrg: string;
  ttlTrpsCnt: any = [];
  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router
  ) {
    this.rdrctUlbDtls = [];
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.rdrctUlbDtls = this.TransfereService.getLoclData("ulbDta");
    this.clntDtls[0].tnts.forEach((element) => {
      this.tntLst.push(element);
    });
    if (this.rdrctUlbDtls) {
      this.ontntSelect(this.rdrctUlbDtls.tnt_id);
      this.slctdDt = this.rdrctUlbDtls.slctdDt;
    } else {
      this.selectedtenant = this.tntLst[0].tnt_id;
      this.selectedtenantNm = this.tntLst[0].tnt_dsply_nm;
    }
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };
  ngOnInit(): void {
    this.curYr = moment(this.today).format("YYYY");
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_totalTripsCount();
    setTimeout(() => {
      this.get_lst7DaysDistanceDta();
    }, 1000);

    this.getTop5Trips();
  }
  ontntSelect(value) {
    console.log(value);
    if (value == 0) {
      this.selectedtenant = 0;
      this.selectedtenantNm = "All ULB's Selected";
      this.ulb_id = 0;
    } else {
      for (let i = 0; i < this.tntLst.length; i++) {
        console.log(this.tntLst);
        if (this.tntLst[i].tnt_id == value) {
          this.selectedtenant = this.tntLst[i].tnt_id;
          this.selectedtenantNm = this.tntLst[i].tnt_dsply_nm;
        }
      }
    }

    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_totalTripsCount();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
  }
  onChange(e): void {
    this.slctdDt = e;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_totalTripsCount();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
  }
  getCoveredTripsCount(): any {
    this.tdyCoveredTrips = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/scndry/getCoveredTripsCount/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tdyCoveredTrips = res["data"];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getTripsData() {
    this.tripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.ttlColumnDefs = [];
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/scndry/ulb/getCoveredTripsDetails`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tripsData = res["data"];
          console.log(this.tripsData);
          this.cvrge_prcnt = 0;
          this.tripsData.forEach((e) => {
            this.cvrge_prcnt += parseFloat(e.coverage_per) || 0;
          });

          this.columnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              width: 50,
              filter: false,
              fixed: true,
            },
            // { headerName: 'ULB', field: 'ZONE', alignment: 'left',fixed:true },
            // { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left',fixed:true},
            { headerName: "Vehicles", field: "TOT_VEHICLES" },
            { headerName: "Category", field: "asrt_ctgry_nm" },
            { headerName: "Total Trips", field: "TOTAL_TRIPS" },
            { headerName: "Completed Trips", field: "OPERATED" },
            { headerName: "Started Trips", field: "STARTED_TRIP" },
            { headerName: "Route Deviated", field: "ROUTE_DEVIATED" },
            { headerName: "Travle Distance(KM)", field: "trvl_dist" },
            { headerName: "Coverage %", field: "coverage_per" },
            { headerName: "Vehicle Status", field: "asrt_sts_nm" },
          ];
        }
        this.showLdr = false;
        this.ttlColumnDefs = [
          {
            headerName: "Vehicles",
            field: "TOT_VEHICLES",
            alignment: "Center",
            summaryType: "count",
          },
          {
            headerName: "Total Trips",
            field: "TOTAL_TRIPS",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Completed Trips",
            field: "OPERATED",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Started Trips",
            field: "STARTED_TRIP",
            alignment: "Center",
            summaryType: "sum",
          },

          {
            headerName: "Route Deviated",
            field: "ROUTE_DEVIATED",
            alignment: "Center",
            summaryType: "sum",
          },
          {
            headerName: "Travel Distance",
            field: "trvl_dist",
            alignment: "Center",
            summaryType: "sum",
            format: { type: "fixedPoint", precision: 2 },
          },
          {
            headerName: "Coverage %",
            field: "coverage_per",
            alignment: "Center",
            summaryType: "avg",
            format: { type: "fixedPoint", precision: 2 },
          },
        ];
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  onCellPrepared(colDef, e) {
    if (
      e.rowType === "data" &&
      e.row.data &&
      e.column.dataField == "TOT_VEHICLES"
    ) {
      e.cellElement.style.color = "rgb(0 142 255)";
      e.cellElement.style.fontWeight = 500;
      e.cellElement.style.borderRadius = "10px";
      e.cellElement.style.cursor = "pointer";
    }
  }
  devCellclk(devclmns, dvclkent) {
    // console.log(dvclkent);
    if (dvclkent.columnIndex == 1) {
      if (dvclkent.data.TOT_VEHICLES != undefined) {
        this.rowselected = dvclkent.data;
        this.rowselected.slctdDt = this.slctdDt;
        this.rowselected.asrt_nm = dvclkent.data.TOT_VEHICLES;
        this.TransfereService.setLoclData("svmDta", this.rowselected);
        this.route.navigate([
          `internal/dashboard/scndrytripvechileCvrge-dashboard`,
        ]);
      }
    }
  }
  // lst7DayDstnc;
  get_lst7DaysDistanceDta(): any {
    let chart = am4core.create("coverageChart", am4charts.XYChart);
    chart.data = [];
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/scndry/trpsCvrgeLast7Days/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe((res) => {
      chart.data = res["data"];

      // Ensure Average Coverage card perfectly matches the Coverage in Last 7 Days chart
      if (chart.data && chart.data.length > 0) {
        let latestData = chart.data[chart.data.length - 1];
        this.avg_cvrg = latestData.coverage_per
          ? parseFloat(latestData.coverage_per).toFixed(2)
          : "0.00";
      } else {
        this.avg_cvrg = "0.00";
      }

      console.log(chart.data);

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "dt";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = -45;
      categoryAxis.title.text = ` ----- Date(${this.curYr})----- `;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      valueAxis.title.text = " ----- Covered % ----- ";
      chart.colors.list = [
        am4core.color("#f7babd"),
        // am4core.color("#7d64c4"),
      ];
      function createSeries(field, name) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "dt";
        series.name = name;
        series.columns.template.tooltipText =
          "{name} in {categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.8;
        series.columns.template.height = am4core.percent(100);
        series.sequencedInterpolation = false;

        let columnTemplate1 = series.columns.template;
        columnTemplate1.strokeWidth = 1;
        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueY}";
        valueLabel.label.fontSize = 15;
        valueLabel.label.dy = 10;
        columnTemplate1.column.cornerRadiusTopLeft = 5;
        columnTemplate1.column.cornerRadiusTopRight = 5;
        columnTemplate1.strokeOpacity = 1;

        let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
      }

      createSeries("coverage_per", "Coverage");
    });
  }
  getTop5Trips() {
    this.toptripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/scndry/getTop10Coverages/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.toptripsData = res["data"];

          this.topTripscolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left", width: 200 },
            {
              headerName: "Vehicles",
              field: "asrt_nm",
              alignment: "left",
              width: 200,
            },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "Center",
              width: "auto",
            },
          ];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  // onExporting1() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  // onExporting2() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  get_totalTripsCount() {
    this.ttlTrpsCnt = [];
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    let postData: any = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/ttlTrips/${this.dbrd_ky}`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        let data = res["data"];
        if (data && data.length > 0) {
          this.ttlTrpsCnt = [
            {
              rts_dfnd: data[0].secondary_rts_dfnd || 0,
              rts_not_dfnd:
                (data[0].secondary_def_trps || 0) -
                (data[0].secondary_rts_dfnd || 0),
              trvl_trps: data[0].secondary_trvl_trps || 0,
              def_trps: data[0].secondary_def_trps || 0,
              nt_trvl_trps:
                (data[0].secondary_def_trps || 0) -
                (data[0].secondary_trvl_trps || 0),
            },
          ];
        }
      },
      (err) => {}
    );
  }

  goBack() {
    this.TransfereService.ClearLocalData("ulbDta");
    this.route.navigate([`internal/dashboard/scndrytripCvrge-dashboard`]);
  }
}
